import { Factory } from '../../services/Factory';
import { ProjectService } from '../../services/project/ProjectService';
import { TrackService } from '../../services/auditing/TrackService';
import { UsageType } from '../../model/project/UsageType';

interface AddProjectControllerScope extends angular.IScope {
    stripe: Stripe.Stripe;
    elements: Stripe.StripeElements;
    addressElement: Stripe.StripeAddressElement;
    cardElement: Stripe.StripeCardElement;
  }

export class AddProjectController {
  constructor(private scope: AddProjectControllerScope, private location: angular.ILocationService, uibModalInstance: angular.ui.bootstrap.IModalInstanceService, organization, private projectService: ProjectService, private notificationService, private trackService: TrackService, private configService) {
    scope.organization = organization;
    scope.creditCardInputReady = false;
    scope.creditCardBillingInputReady = false;

    scope.close = () => {
      if (!scope.saving) {
        scope.addressElement.unmount();
        scope.addressElement.destroy();

        uibModalInstance.close();
      }
    };

    scope.forms = {};
    scope.newProject = {};
    scope.saving = false;
    scope.UsageTypes = [{id: UsageType.Processing, name: Object.keys(UsageType)[0]}, {
      id: UsageType.ECA,
      name: Object.keys(UsageType)[1]
    }, {id: UsageType.Review, name: Object.keys(UsageType)[2]}];

    // After custom validation, we clear it out with this method
    scope.setValid = elm => {
      _.each(elm.$error, (value, key, list) => {
        if (value && key !== "required") {
          elm.$setValidity(key, true);
        }
      });
    };

    uibModalInstance.rendered.then(() => {
      scope.stripe = (<any>Stripe)(configService.getStripePubKey());
      const options: Stripe.StripeAddressElementOptions = {mode: "billing"};
      const cardOptions: Stripe.StripeCardElementOptions = {disableLink: true, hidePostalCode: true, classes: { base: "stripe-card"}};
      const appearance: Stripe.Appearance = {
        labels: "floating",
        variables: {
          colorPrimary: '#0570de',
          colorTextPlaceholder: "#555555",
          gridRowSpacing: "4px",
          borderRadius: "4px",
          fontSizeBase: "14px"
        }
      };
      scope.elements = scope.stripe.elements({appearance});
      scope.addressElement = scope.elements.create("address", options);
      scope.cardElement = scope.elements.create("card", cardOptions);
      scope.addressElement.mount("#address-element");
      scope.cardElement.mount("#card-element");

      scope.addressElement.on("change", (e: Stripe.StripeAddressElementChangeEvent) => {
        scope.creditCardBillingInputReady = e.complete;

        scope.$applyAsync();
      });

      scope.cardElement.on("change", (e: Stripe.StripeCardElementChangeEvent) => {
        scope.creditCardInputReady = e.complete;

        scope.$applyAsync();
      });
    });

    scope.saveProject = !organization ? async project => {
      scope.saving = true;
      const address = await scope.addressElement.getValue();

      if (!address.complete) {
        scope.saving = false;
        scope.$applyAsync();
      }

      scope.stripe.createToken(scope.cardElement, {
        name: address.value.name,
        address_line1: address.value.address.line1,
        address_line2: address.value.address.line2 ?? "",
        address_city: address.value.address.city,
        address_state: address.value.address.state,
        address_zip: address.value.address.postal_code,
        address_country: address.value.address.country
      }).then(response => {
        if (response.error) {
          // re-enable the submit button
          scope.saving = false;
        } else {
          this.CreateProject(project, response.token.id);
        }

        scope.$apply();
      });

    } : this.CreateProject.bind(this);
  }

  private CreateProject(project, token) {
    let newProject = this.projectService.Create(<any>{
      token: (token === null || token === undefined) ? "" : token,
      name: project.name,
      description: project.description,
      promoCode: project.promoCode,
      organizationId: this.scope.organization?.id,
      usageType: project.usageType[0]?.id,
    });

    this.projectService.Save(newProject).then(project => {
      this.scope.saving = false;
      this.scope.close();

      this.notificationService.addSuccess({
        title: "Project added successfully",
        description: "You should receive an email shortly with your project information",
        timeout: 5000
      });

      this.trackService.TrackCreditCardEnteredConversion();

      this.location.path(`/project/${project.id}/getstarted`);
    }, () => this.scope.saving = false);
  }
}

frontendApp.controller("AddProjectController", ["$scope", "$location", "$uibModalInstance", "organization", "ProjectService", "NotificationService", "TrackService", "ConfigService", Factory.Create(AddProjectController)]);
